import { HStack, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { LockIcon } from "../icons/reader/LockIcon";

interface CommentsDisabledProps {
  color?: string;
  fontSize?: string;
  fontWeight?: string;
  iconSize?: string;
  spacing?: string;
}

export function CommentsDisabled({
  color = "neutral.300",
  fontSize = "14px",
  fontWeight = "500",
  iconSize = "16px",
  spacing = "8px",
}: CommentsDisabledProps) {
  const { t } = useTranslation();

  return (
    <HStack spacing={spacing} color={color}>
      <LockIcon boxSize={iconSize} color="blaze.blaze" />
      <Text fontSize={fontSize} fontWeight={fontWeight}>
        {t("screens.reader.commentsMenu.commentsDisabled")}
      </Text>
    </HStack>
  );
}